let slider = null;
document.addEventListener("DOMContentLoaded", function () {
    slider = new Swiper('.eggo-review-slider', {
        slidesPerView: 'auto',
        spaceBetween: 12,
        breakpoints: {
            767: {
                spaceBetween: 24
            }
        }
    });
    registerTabs();
    showInitialReviewCards();
});

const registerTabs = () => {
    const tabElements = document.querySelectorAll(".eggo-product-text-card-products__single");
    tabElements.forEach((tabElement) => {
        tabElement.addEventListener("click", () => {
            tabElements.forEach((tabElement) => tabElement.classList.remove("active"));
            tabElement.classList.add("active");
            showReviewCards(tabElement.dataset.product);
            showMiniProductCards(tabElement.dataset.product);
            slider.update();
        });
    })
}

const showInitialReviewCards = () => {
    const activeReviews = document.querySelector(".eggo-product-filtered-reviews .eggo-product-text-card-products__single");
    if (!activeReviews) return;
    showReviewCards(activeReviews.dataset.product);
    slider.update();
}

const showReviewCards = (productId) => {
    const reviewCards = document.querySelectorAll(".review-card");
    reviewCards.forEach(reviewCard => reviewCard.classList.remove("active"));
    const productReviewCards = document.querySelectorAll(`.review-card[data-product='${productId}']`);
    productReviewCards.forEach((productReviewCard => productReviewCard.classList.add("active")));
}

const showMiniProductCards = (productId) => {
    const productCardsSecondary = document.querySelectorAll(".product-card-secondary");
    productCardsSecondary.forEach(productCardSecondary => productCardSecondary.classList.remove("active"));
    const productCardSecondary = document.querySelector(`.product-card-secondary[data-product='${productId}']`);
    productCardSecondary.classList.add("active");
}